<template>
  <div class="form-header">
    <div class="target">
      <div class="sub-text">Our target</div>
      <div class="number">{{ targetText }}</div>
    </div>

    <div class="progress-bar">
      <div class="progress-bar-wrapper">
        <div
          class="progress-bar-inner"
          :style="{ width: 100 - percent + '%' }"
        ></div>
      </div>
      <div
        class="edo-tree-icon"
        :style="{
          left: 'calc(' + percent + '% - (' + percent / 100 + '* 64px))',
        }"
      >
        <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3519/dist/assets/img/LR - Progress bar icon.svg" />
      </div>
    </div>

    <h2 class="counter">
      {{ Math.ceil(currentCounter) }}
    </h2>

    <h5>{{ headerText }}</h5>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "LeafReliefHeader",

  data() {
    return {
      currentCounter: 0,
      percent: 0,
      subscriptions: [],
    };
  },
  props: {
    datalayerName: {
      type: String,
      required: true,
    },
    counterLimit: {
      type: Number,
      default: 100,
    },
    targetText: {
      type: String,
      default: "1 Million",
    },
    headerText: {
      type: String,
      default:
        "Join us in our quest to plant 2 billion trees and restore our unique habitat",
    },
  },

  created: async function () {
    this.subscriptions.push(
      await firebase
        .firestore()
        .collection("campaigns")
        .doc(this.datalayerName)
        .onSnapshot(
          (snapshot) => {
            const data = snapshot.data();
            if (!!data) {
              this.setCounter(data.count);
            }
          },
          (error) => {
            console.error(err);
          }
        )
    );
  },
  methods: {
    async setCounter(value) {
      this.$store.commit("updateTreeCount", value);

      value = value > this.counterLimit ? this.counterLimit : value;
      this.percent = (value / this.counterLimit) * 100;
      const delta = value - this.currentCounter;
      let increment = delta / 351;
      const wait = 2800 / 351;
      do {
        if (this.currentCounter + increment > value) {
          this.currentCounter = value;
        } else {
          this.currentCounter += increment;
        }
        await this.sleep(wait);
      } while (this.currentCounter < value);
    },
    sleep(time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
  },
  beforeDestroy: function () {
    // Unsubscript from all subscriptions
    for (const s of this.subscriptions) {
      s();
    }
  },
};
</script>

<style scoped>
.form-header {
  padding: 2rem;
  background-color: var(--wwfRegenerateAustralia);
  color: var(--wwfWhite);
}

/* TARGET */

.target {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 1rem;
  font-family: var(--wwfFont);
  letter-spacing: 1.5px;
}

.target .number {
  text-align: left;
  font-size: 30px;
  line-height: 32px;
}

.target .number:first-letter {
  text-transform: uppercase;
}

.target .sub-text {
  font-size: 24px;
  line-height: 28px;
}

/* COUNTER */

.form-header h2.counter {
  width: 100%;
  text-align: center;
  font-size: 100px;
}

/* TITLE */

.form-header h5 {
  width: 100%;
  text-align: center;
  font-size: 24px;
  line-height: 26px;
  letter-spacing: 1px;
  font-family: var(--wwfFont);
}

/* PROGRESS BAR */

.progress-bar {
  position: relative;
  height: 100px;
}

.edo-tree-icon {
  position: absolute;
  width: 64px;
  height: 64px;
  top: 7px;
  left: -32px;
  transition: all 3s linear;
}

.progress-bar-wrapper {
  position: absolute;
  width: 100%;
  height: 32px;
  padding: 2px;
  margin: 25px 0;
  background-color: var(--wwfWhite);
  border-radius: 16px;
}

.progress-bar-inner {
  float: right;
  background-color: var(--wwfRegenerateAustralia);
  width: 100%;
  min-width: 32px;
  height: 100%;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  transition: all 3s linear;
}

@media only screen and (max-width: 40em) {
  .petition-counter {
    margin: -20px -20px 40px;
    padding: 20px 20px 0px;
  }

  .petition-form.wwf-form {
    padding: 0;
  }
}
</style>


// WEBPACK FOOTER //
// Header.vue?05c6f7a9